import styled from "@emotion/styled";

export const FieldWrapper = styled.div`
  margin-bottom: 10px;
  label {
    font-size: 12px;
  }
  & > .toggle-buttons {
    margin-top: 5px;
    padding: 0px;
    height: 40px;
    background-color: #f4f4f4;
    border-radius: 0.875rem;
    div {
      width: 100%;
      height: 40px;
      button {
        font-size: 12px;
        height: 30px;
        display: flex;
        align-items: center;
        border-radius: 8px;
      }
    }
  }
`;

export const Input = styled.input`
  width: 100%;
  border: none;
  background-color: #f4f4f4;
  border-radius: 0.875rem;
  height: 40px;
  padding-left: 20px;
  padding-right: 10px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 3px;
  padding-left: 40px;
`;

export const SelectedWrapper = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const SelectedIcon = styled.span`
  color: grey;
  font-size: 12px;
  margin-right: 10px;
  width: 0px;
`;

export const SelectedFont = styled.span`
  font-size: 12px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  color: grey;
`;

export const SelectButton = styled.button`
  padding: 0px;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  color: #2f8de4;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  i {
    font-size: 14px;
    margin-left: 10px;
  }
`;

export const LeftSelectCol = styled.div`
  display: flex;
  gap: 10px;
  flex: 1;
`;

export const RightSelectCol = styled.div`
  flex: 1;
  display: flex;
  justify-content: end;
`;

export const SearchWrapper = styled.div``;

export const ListWrapper = styled.div`
  max-height: 120px;
  overflow-y: scroll;
`;

export const SelectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0px;
  margin: 5px 0px;
  background-color: #fff; //#f4f4f4;
  cursor: pointer;
`;

export const FontTitle = styled.span`
  font-size: 12px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  color: grey;
`;

export const SelectionButton = styled.button`
  border-radius: 100%;
  min-height: 1.5625rem;
  min-width: 1.5625rem;
  font-size: 1.375rem;
  padding: 0rem;
  margin: 0rem;
  justify-content: center;
  color: grey;
  border: none;
  background: transparent;
  &.active {
    color: #2f8de4;
  }
`;

export const CategoriesWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding-bottom: 10px;
`;

export const CategoryButton = styled.button<{ active: boolean }>`
  background-color: ${({ active }) => (active ? "#2f8de4" : "#fff")};
  color: ${({ active }) => (active ? "#fff" : "grey")};
  border: none;
  padding: 7.5px 15px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
`;

export const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BottomWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding-top: 10px;
`;

export const ResetButton = styled.button`
  width: 30px;
  padding: 0px;
  border: none;
  background: none;
  color: grey;
  i {
    font-size: 18px;
  }
`;

export const ResultsWrapper = styled.div``;

export const ResultLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  color: grey;
`;

export const NoResultsWrapper = styled.div`
  padding: 20px 0px;
  text-align: center;
`;

export const NoResultsLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  color: grey;
`;

export const SearchInput = styled.input`
  border: none;
  background: none;
  font-family: "Poppins", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  padding: 5px 25px;
  border-bottom: 0.0625rem solid #e1e1e1;
  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 17.5px;
  top: 11px;
  color: grey;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  input {
    width: 100%;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  top: 14px;
  right: 10px;
  border: none;
  background: transparent;
  z-index: 4;
  color: grey;
  i {
    font-size: 14px;
  }
`;
